export enum SessionTimeoutType {
  FifteenMinutes = 'FifteenMinutes',
  OneHour = 'OneHour',
  EndOfTheDay = 'EndOfTheDay',
}
